// Teléfono argentino como lo quiere WhatsApp: 549 + área + número, sin el 0
// ni el 15.
//
// El número nacional tiene 10 dígitos (área de 2 a 4 + abonado). El «15» del
// celular solo se saca si está de más: si sin el 0 quedan 12 dígitos y el 15
// viene justo después de un área de 2, 3 o 4 dígitos (en ese orden). Antes se
// sacaba el primer «15» después de 2 a 4 dígitos aunque el número ya tuviera
// 10: 11 4515 1234 quedaba 11 451 234.
export function waNumero(tel: string): string {
  let d = tel.replace(/\D/g, "");
  if (d.startsWith("549")) return d;
  if (d.startsWith("54")) d = d.slice(2);
  if (d.startsWith("0")) d = d.slice(1);
  if (d.length === 12) {
    const area = [2, 3, 4].find((n) => d.slice(n, n + 2) === "15");
    if (area) d = d.slice(0, area) + d.slice(area + 2);
  }
  return "549" + d;
}
